// extracted by mini-css-extract-plugin
export default {"SectionTitle":"FormSectionTitle_SectionTitle__T7paH"};